/**
 * One way to print a place of performance. Fields arrive as plain strings
 * from the API; an empty part is dropped rather than rendered as ", USA".
 * Country is shown only when it is not the United States.
 */
export interface PlaceOfPerformance { city?: string | null; state?: string | null; zip?: string | null; country?: string | null }

const US = new Set(['USA', 'US', 'UNITED STATES', 'UNITED STATES OF AMERICA']);

export function formatLocation(pop?: PlaceOfPerformance | null, opts: { zip?: boolean } = {}): string {
  if (!pop) return '';
  const clean = (v?: string | null) => { const t = (v || '').trim(); return t === '0' || t === 'N/A' ? '' : t; };
  const city = clean(pop.city), state = clean(pop.state), zip = opts.zip ? clean(pop.zip) : '', country = clean(pop.country);
  const parts = [city, state].filter(Boolean);
  let out = parts.join(', ');
  if (zip) out = out ? `${out} ${zip}` : zip;
  if (country && !US.has(country.toUpperCase())) out = out ? `${out}, ${country}` : country;
  return out;
}
